"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateAfterCloneRecipe = exports.cloneRecipeMutation = void 0;
const client_1 = require("@apollo/client");
const meUser_1 = require("../../user/fragments/meUser");
const recipePreviewFragment_1 = require("../fragments/recipePreviewFragment");
const CreateRecipe_1 = require("./CreateRecipe");
exports.cloneRecipeMutation = client_1.gql `
  mutation CloneRecipe($options: CloneRecipeInput!) {
    cloneRecipe(options: $options) {
      __typename
      ok
      recipe {
        ...RecipePreview
      }
      user {
        ...meUser
      }
    }
  }
  ${meUser_1.meUserFragment}
  ${recipePreviewFragment_1.recipePreviewFragment}
`;
exports.updateAfterCloneRecipe = (variables, cookbookId) => (store, { data }) => __awaiter(void 0, void 0, void 0, function* () {
    if (!data) {
        return;
    }
    const { cloneRecipe: { recipe }, } = data;
    if (!recipe) {
        return;
    }
    CreateRecipe_1.updateCacheNewRecipe(store, recipe, variables.options.sectionId, cookbookId);
});
//# sourceMappingURL=cloneRecipe.js.map